import React from 'react'
import _ from 'lodash'
import Slider from 'react-slick'
import SliderSettings from '~/tools/slickSliderSettings'
import Link from '~/components/Link'
import NetflixTrayItem from './netflix-tray-item'
import TrayItem from './trayItem'
import BlockTitle from '~/components/BlockTitle'
import pageStore from '~/redux/page/store'

import 'slick-carousel/slick/slick.css'
import './style.scss'

class Tray extends React.Component {
  constructor(props) {
    super(props)
    var page = pageStore.getState()
    var categoryMap = page.data.categoryMap
    var filter = _.get(props, 'data.filters.categories[0]')
    this.state = {
      categoryUrl: _.get(props, 'data.categoryUrl') || (filter && categoryMap && categoryMap[filter]),
      filter: _.get(props, 'data.filter', filter),
      items: _.get(props, 'data.contentData', []),
      title: _.get(props, 'data.title', '') || props.title,
      seeAllPermalink: _.get(props, 'data.settings.seeAllPermalink')
    }

    this.goToTrayItem = this.goToTrayItem.bind(this)
  }

  componentDidMount(){
    this.setState({
      innerWidth: window.innerWidth
    })
    const nextButton = this.container.querySelector(".slick-next");
    nextButton !== null && nextButton.addEventListener('click', (e)=>{
      (!this.state.clickNext)  &&  this.setState({
        clickNext: true
      })
    })
  }

  componentWillReceiveProps(nextProps){
      if(!_.isEmpty(nextProps.title)) {
          this.setState({
              title: nextProps.title
          })
      }
      if(nextProps.dataToShow) {
          if(nextProps.dataToShow.length > 0) {
              this.setState({items: nextProps.dataToShow})
          } else {
               this.setState({items: []})
          }
      } else {
          this.setState({
              items: _.get(nextProps, 'data.contentData', [])
          })
      }
  }

  goToTrayItem(idx) {
    this.slider.slickGoTo(idx)
  }

  render() {
    const settings = this.props.layout.settings
    const columns = settings.columns || {
			desktop: 7,
			mobile: 3,
			tablet: 6,
			ott: 7
		}
    const hasMultipleItems = _.get(this.state, 'items.length', 0) > columns.desktop
    const sliderSettings = new SliderSettings(columns)

    return (
      <div
        ref={el => this.container = el}
        className={`video-tray ${settings.infoHover ? 'infoHover' : ''} ${settings.thumbnailType ? settings.thumbnailType : ''} ${_.get(this.props, 'layout.settings.isHidden') ? 'hide' : ''}`}
      >

      <div className={this.props.neouTrayTitle ? "tray-wrapper" : "tray-wrapper-common"}> {/* Only for NEOU video tray, neouTrayTitle is true */}
        { _.get(this.props, 'data.noBlockTitle')
          ? <div className="tray-header">{this.state.title}</div>
          : this.state.title && <BlockTitle>{this.state.title}{this.props.showCount && this.state.items && <span>{` (${this.state.items.length})`}</span>}</BlockTitle>
        }
        { (_.get(this.props, 'data.settings.seeAll') && _.get(this.props, 'data.settings.seeAllPermalink'))
          ? <Link href={_.get(this.props, 'data.settings.seeAllPermalink')} className="tray-detail"><i className="ion-chevron-right"/></Link>
          : null
        }
        </div>
        <div className="items">
          { this.state.items && this.state.items.length > 0 &&
            <Slider
              ref={ el => this.slider = el }
              dots={false}
              infinite={settings.loop}
              arrows={hasMultipleItems}
              slidesToShow={ sliderSettings.slidesToShow }
              slidesToScroll={ sliderSettings.slidesToScroll }
              responsive={ sliderSettings.responsiveBreakpoints }
              lazyLoad={this.props.lazyLoad === undefined ? true: this.props.lazyLoad}
              draggable={this.props.draggable}
              {...this.props.settings}>

              { this.state.items.map((item, i) => (
                <div key={i}>
                  {!this.props.netflix ?
                    <TrayItem
                      {...settings}
                      item={item}
                      maxWidth={this.state.innerWidth < 600 ? sliderSettings.mobileMaxWidth : sliderSettings.maxWidth }
                      isEpisode={ _.get(this.props, 'data.isEpisode') }
                      noEpisodeNumber={this.props.data.noEpisodeNumber}
                      index={i}
                      season={this.props.season}
                      sharing={this.props.data.sharing}
                      noBoxshadow={this.props.data.noBoxshadow}
                      openEpisodeOverlay={this.props.openEpisodeOverlay}
                      onFocus={this.goToTrayItem}
                      clickNext={this.state.clickNext}
                      trayTitle={this.props.trayTitle ? this.props.trayTitle : this.state.title}
                      lazyLoad={this.props.lazyLoad === undefined ? true: this.props.lazyLoad}
                      refItems={this.state.items}
                    />
                  :
                    <NetflixTrayItem
                      {...settings}
                      noBadgeImage={this.props.noBadgeImage}
                      item={item}
                      maxWidth={this.state.innerWidth < 600 ? sliderSettings.mobileMaxWidth : sliderSettings.maxWidth}
                      isEpisode={_.get(this.props, 'data.isEpisode')}
                      noEpisodeNumber={this.props.data.noEpisodeNumber}
                      index={i}
                      season={this.props.season}
                      sharing={this.props.data.sharing}
                      noBoxshadow={this.props.data.noBoxshadow}
                      openEpisodeOverlay={this.props.openEpisodeOverlay}
                      onFocus={this.goToTrayItem}
                      clickNext={this.state.clickNext}
                      lazyLoad={this.props.lazyLoad === undefined ? true : this.props.lazyLoad}
                      refItems={this.state.items}
                      slidesToScroll={sliderSettings.slidesToScroll}
                      hideCategories={this.props.hideCategories}
                      showCount={this.props.showCount}
                      showProgressBar = {this.props.showProgressBar || false}
                      showDetailsBottom = {this.props.showDetailsBottom || false}
                      showPlayIcon = {this.props.showPlayIcon || false}
                      onlyPrimaryCategory = {this.props.onlyPrimaryCategory}
                    />
                  }
                </div>
              )) }
              {(this.state.categoryUrl && this.state.seeAllPermalink) &&
                <a className="tray-last-item" href={this.state.categoryUrl}>
                  <div className="image-and-details">
                    { settings.thumbnailType !== 'landscape' &&
                      <div className="image">
                        <img src={ _.get(window.settings, 'images.desktopLogo') } alt="logo"/>
                      </div>
                    }
                    <div className="details">
                      <div className="see-all">See All</div>
                      <div className="category-name">{ this.state.filter }</div>
                    </div>
                  </div>
                </a>
              }
          </Slider>
        }
        </div>
      </div>
    )
  }
}

export default Tray;
